import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {Events, Platform} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import {StatusBar} from '@ionic-native/status-bar';
import {AngularFireDatabase} from "angularfire2/database";

import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../services/auth';

import { Device } from '@ionic-native/device';
import {LogService} from "../services/logger";
import {ConnectivityService} from "../services/connectivity";

import { ENV } from "@app/environment"

const httpOptions = {
    'headers': new HttpHeaders({})
}

@Injectable()
export class PortalDataService {

    public endpoint: any = "/portal";
    public version: any = "1.0" ;
    public  needProvideFromServer = false;


    constructor(
        public events: Events,
        public storage: Storage,
        public afDatabase: AngularFireDatabase,
        private afAuth: AngularFireAuth,
        public authService: AuthService,
        public logger: LogService,
        public http: HttpClient,
        public connectivity: ConnectivityService,
        public platform: Platform
    ) {

        // Dynamiccaly change the configuration proxy used for portal (see ionic.config.json)
        if (this.platform.is('core')) {
            this.endpoint = ENV.PORTAL_PROXY;
        }
        else
        {
            this.endpoint = ENV.PROXIES_URL[ENV.PORTAL_PROXY];
        }
        this.endpoint = this.endpoint+"/api/"+this.version+"/service/";
    }
    /***
     * Create provide request
     * @param token : user token
     */
    provideRequest(
        type, id
    ) {
        var token = "token"; // todo : provide here HASHED token to sign the http request
        var url = this.endpoint+'provide/'+type+"/"+id+"/"+token+".json";
        this.logger.log(url);
        this.logger.log(httpOptions);
        let headers = new Headers(
            {
                'Content-Type' : "application/json"
            });

        let options = new RequestOptions({ headers: headers });
        var that = this;
        this.http.post(url,false,httpOptions).subscribe(data => {
            that.logger.log("SUCCESS");
            that.logger.log(data);
        }, error => {
            that.logger.log("ERROR");
            that.logger.log(error);
        });
    }

    setNeedProvideFromServer(flag = true)
    {
        this.needProvideFromServer=flag;
    }
    /***
     * Create sync request
     * @param token : user token
     */
    syncRequest(
        type, id
    ) {
        var token = "token"; // todo : provide here HASHED token to sign the http request
        var url = this.endpoint+'sync/'+type+"/"+id+"/"+token+".json";
        this.logger.log(url);
        this.logger.log(httpOptions);
        let headers = new Headers(
            {
                'Content-Type' : "application/json"
            });
        let options = new RequestOptions({ headers: headers });
        var that = this;

        this.http.post(url,false,httpOptions).subscribe(data => {
            that.logger.log("SUCCESS");
            that.logger.log(data);
            if(that.needProvideFromServer)
            {
                that.provideRequest(type, id);
                that.needProvideFromServer=false;
            }
        }, error => {
            that.logger.log("ERROR");
            that.logger.log(error);
        });
    }

    /***
     * Ask portal to provide User data in Firebase
     * @param token : user token
     */
    provideUserData(
        token
    ) {
        this.logger.log('Refresh User Data : '+token);
        this.provideRequest('user',token);
    }
    /***
     * Ask portal to provide User data in Firebase
     * @param token : user token
     */
    syncUserData(
        token
    ) {
        this.logger.log('Sync User Data : '+token);
        this.syncRequest('user',token);
    }
    /***
     * Ask portal to provide User data in Firebase
     * @param token : user token
     */
    markAsModified(
        type,
        id,
        registry
    ) {
        if(this.connectivity.isOnline()) {
            this.afDatabase.list('/needSync/' + type +'/'+id).push(registry);
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/portal-data.ts